<div class="project-view__container" *transloco="let t; read: 'project-view'">
  <div class="project-view__header-container">
    @if (!isLoading) {
      <div class="project-view__header-bar">
        <div class="project-view__project-title-wrapper">
          <h1 class="project-view__project-title">
            <ng-container *appMiddleEllipsize="project.name"></ng-container>
          </h1>
        </div>
        @if (!isExecutive) {
          <div class="project-view__header-actions">
            @if (isAdmin) {
              <div [matMenuTriggerFor]="dataMenuTrigger">
                <xi-icon-button
                  buttonSize="large"
                  color="orca"
                  icon="download"
                  [hasAnimation]="true"
                >
                </xi-icon-button>
              </div>
            }
            <xi-icon-button
              (click)="openOptionsDrawer()"
              color="orca"
              buttonSize="large"
              icon="settings"
              [tooltip]="{ text: t('project-options') }"
              [hasAnimation]="true"
            >
            </xi-icon-button>
            @if (!isReadOnly) {
              <div>
                <xi-icon-button
                  color="orca"
                  buttonSize="large"
                  icon="trash"
                  [hasAnimation]="true"
                  [tooltip]="{ text: t('delete-project'), direction: 9 }"
                  (onClick)="deleteProjectDialog(project)"
                >
                </xi-icon-button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="project-view__content-wrapper" [ngClass]="isLoading ? 'project-view--hide' : ''">
    <app-project-details-table
      [project]="project"
      [isReadOnly]="isReadOnly"
      [isExecutive]="isExecutive"
      [isAdmin]="isAdmin"
      [isDebug]="isDebug"
    ></app-project-details-table>

    <app-project-details-item-panel
      [project]="project"
      [isReadOnly]="isReadOnly"
      [isExecutive]="isExecutive"
    ></app-project-details-item-panel>
  </div>
</div>

<mat-menu #dataMenuTrigger class="menu-with-xi-icons">
  <ng-container *transloco="let t; read: 'project-view'">
    <button mat-menu-item (click)="downloadProjectData()">
      <xi-icon icon="download"></xi-icon>
      <div>{{ t('download-data') }}</div>
    </button>

    <button mat-menu-item (click)="downloadAnalysisData()">
      <xi-icon icon="download"></xi-icon>
      <div>{{ t('download-analysis') }}</div>
    </button></ng-container
  >
</mat-menu>

@if (openDrawer) {
  <app-project-options-drawer
    [project]="project"
    [drawerOpen]="openDrawer"
    (close)="onOptionsDrawerClosed()"
  ></app-project-options-drawer>
}
@if (isUploadCreateDialogOpen) {
  <app-lex-xi-modal
    [isVisible]="isUploadCreateDialogOpen"
    maxWidth="600px"
    (close)="onCloseUploadCreateDialog(null)"
  >
    <ng-template appXIModalContent>
      @if (isUploadCreateDialogOpen) {
        <app-upload-create
          [project]="project"
          (close)="onCloseUploadCreateDialog($event)"
        ></app-upload-create>
      }
    </ng-template>
  </app-lex-xi-modal>
}
